export enum TipoTempoAntesChekinSemReservaEnum {
    Minuto,
    Hora
  }
  